module.exports = __webpack_public_path__ + "../static/img/switch.0a0c9b6d.png";